<script setup lang="ts">
import { PhProhibit } from '@phosphor-icons/vue';
</script>

<template>
  <div>
    <ph-prohibit class="art-invalid-icon" weight="thin" />
  </div>
</template>

<style scoped>
.art-invalid-icon {
  width: 10rem;
  height: 10rem;
}
</style>
